import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { currentUser, isActivated } = useAuth();
  const location = useLocation();

  if (!currentUser) {
    // Kullanıcı giriş yapmamışsa login'e yönlendir
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isActivated && location.pathname !== '/activation') {
    // Aktivasyon yapılmamışsa ve farklı bir sayfaya erişmeye çalışıyorsa
    return <Navigate to="/activation" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute; 